import React, { Fragment } from "react";
import __ from "lodash";
import {useQueryClient} from "react-query";
import { Icon, makeStyles, Tooltip} from "@material-ui/core";
import { ActionButton } from "./controls";
import { HandshakeIcon } from "../../../icons";
import { useFlights } from "../../../services/flights";
import useColour from "../../../services/settings/useColour";
import AirplaneLandingIcon from "../../../icons/AirplaneLandingIcon";
import AirplaneTakeoffIcon from "../../../icons/AirplaneTakeoffIcon";
import TripToolTipStyles from "../TripToolTipStyles";
import { useAuth0 } from "@auth0/auth0-react";
import { ComboSelect, LightTooltip } from "../..";
import { useAirports } from "../../../services/airports";
import { useTripLegServices } from "../../../services/trips";
import { useSlotInfo } from "../../../services/slots";

const AccessControl = require ("../../../AccessControl");

const SlotsScreen = (props) => {
  const {tripData, eventBus} = props; 

  const classes = makeStyles(TripToolTipStyles)();
  const { user } = useAuth0();
  const canUpdateSlots = AccessControl.userHasAccess(user, ["Super Admin", "Admin", "Manage TRIPS"]);

  const queryClient = useQueryClient();
  const extraKeys = [tripData.uuid];
  const flight = useFlights({queryClient, extraKeys});
  const slotInfo = useSlotInfo({queryClient, extraKeys});
  console.log(slotInfo);
  const tripLegServices = useTripLegServices({queryClient, extraKeys: [tripData.uuid, 'FLAG']});

  let inboundRequired = false;
  let outboundRequired = false;
  if (tripLegServices && tripLegServices.data) {
    inboundRequired = __.findIndex(tripLegServices.data, {serviceCode: 'SLOT REQUIRED', direction: 'IN', isRequired: 1}) > -1;
    outboundRequired = __.findIndex(tripLegServices.data, {serviceCode: 'SLOT REQUIRED', direction: 'OUT', isRequired: 1}) > -1;
  }

/*
slotBookingEmail
slotBookingOnlinePortal
slotBookingWebsite
slotBookingNotes
*/  

  const statusValues = [
    {"code":"REQUIRED","value":"Required"},
    {"code":"REQUESTED","value":"Requested"},
    {"code":"RECEIVED","value":"Confirmed"},
    {"code":"REJECTED","value":"Rejected"},
    {"code":"CANCELLED","value":"Cancelled"},
    {"code":"PENDING","value":"Pending"},
    {"code":"OFFER","value":"Offer"},
    {"code":"CONDITIONAL","value":"Conditional"},
  ];

  const Airport = (props) => {
    const {airportCode} = props;

    const airportRecord = useAirports({queryClient, extraKeys: [airportCode], useCache: true});
    let contactDetails = [];
    if (airportRecord && Array.isArray(airportRecord.data) && airportRecord.data.length > 0) {
      const airport = airportRecord.data[0];
      if (airport.slotBookingEmail) contactDetails.push( 
        <div className={classes.contactRow}>
          <div style={{display: "inline-block"}}>
            Email:
          </div>
          <div style={{display: "inline-block"}}>
            <a href={`mailto:${airport.slotBookingEmail}`}>{airport.slotBookingEmail}</a>
          </div>
        </div>
      )
      if (airport.slotBookingOnlinePortal) contactDetails.push(
        <div className={classes.contactRow}>
          <div style={{display: "inline-block"}}>
            Portal:
          </div>
          <div style={{display: "inline-block"}}>
            <a href={`https://${airport.slotBookingOnlinePortal}`} target="slot_portal">{airport.slotBookingOnlinePortal}</a>
          </div>
        </div>
      )
      if (airport.slotBookingWebsite) contactDetails.push(
        <div className={classes.contactRow}>
          <div style={{display: "inline-block"}}>
            Website:
          </div>
          <div style={{display: "inline-block"}}>
            <a href={`https://${airport.slotBookingWebsite}`} target="slot_website">{airport.slotBookingWebsite}</a>
          </div>
        </div>
      )
      if (airport.slotBookingNotes) contactDetails.push(
        <div className={classes.contactRow}>
          <div style={{display: "inline-block"}}>
            Notes:
          </div>
          <div>
            {airport.slotBookingNotes}
          </div>
        </div>
      )
    }

    if (contactDetails.length > 0) {
      return (
        <LightTooltip 
          arrow 
          interactive
          title={<div>{contactDetails.map(row => row)}</div>}
          leaveDelay={200}
        >
          <div>({airportCode})</div>
        </LightTooltip>  
      )
    }

    return (
      <div>({airportCode})</div>
    )
  }

  const SlotRow = (props) => {
    const {data} = props;
    const record = {
      status: "REQUIRED",
      time: "",
      slotReference: "",
      service: "",
      ...data
    }

    const backgroundColor = useColour({code: 'SLOTS BACKGROUND', status: record?.status||"REQUIRED"})||"#ff0000";
    const color = useColour({code: 'SLOTS TEXT', status: record?.status||"REQUIRED"})||"#ffffff";

    return (
      <div className={classes.slotRow}>
        <div>
          <div style={{fontWeight: "700", display: "inline-block", width: "35%"}}>Status:</div>
          <div style={{display: "inline-block", maxWidth: "60%", backgroundColor, color, padding:"0px 5px"}}>
            <div style={{position:"relative", display:"block", width: "auto"}}>
            {__.find(statusValues,{code: record?.status||'REQUIRED'}).value}
            {/* <ComboSelect
              group="SLOT STATUS"
              subGroup=""
              value={data.status||"REQUIRED"}
              displayOnly={true}
            /> */}
            </div>
          </div>        
        </div>
        <div>
          <div style={{fontWeight: "700", display: "inline-block", width: "35%"}}>Slot Time:</div>
          <div style={{display: "inline-block", width: "60%"}}>{record.time}</div>        
        </div>
        <div>
          <div style={{fontWeight: "700", display: "inline-block", width: "35%"}}>Slot Reference:</div>
          <div style={{display: "inline-block", width: "60%"}}>{record.slotReference}</div>        
        </div>
        <div>
          <div style={{fontWeight: "700", display: "inline-block", width: "35%"}}>Service Type:</div>
          <div style={{display: "inline-block", width: "60%"}}>
            <ComboSelect
              group="SLOTS"
              subGroup="SERVICE"
              value={record.service}
              displayOnly={true}
            />
          </div>        
        </div>
      </div>
    );
  }
  return (<Fragment>
    <div style={{width: "100%", paddingBottom: 5}}>
      <div style={{display: "inline-block"}}><HandshakeIcon style={{position: "relative", top: 2}}/></div>
      <div style={{display: "inline-block", textAlign: "left", fontSize: 20, fontWeight: "bold", marginLeft: 3}}>Slots</div>
      <div style={{display: "inline-block", float:"right", textAlign: "right"}}>
        {/* <ActionButton 
          variant="outlined" 
          startIcon={<Icon>edit</Icon>}
          onClick={()=>{
            eventBus.trigger("RouteView.TimeWindow.TripAction.editSlots",{tripData: {...flight.data[0]}, extraKeys, canUpdateSlots});
          }}
        >
          Edit
        </ActionButton> */}
      </div>
    </div>
    <div style={{width: "100%"}}>
      {flight && Array.isArray(flight.data) && flight.data.length > 0?
        <>
          <div className={classes.slotDirectionHeader}>
            <div style={{display: "inline-block"}}><AirplaneTakeoffIcon style={{position: "relative", top: 2, width: 16, height: 16}}/></div>
            <div style={{display: "inline-block", textAlign: "left", fontSize: 16, fontWeight: "bold", marginLeft: 3}}>Outbound Slots</div>
            <div style={{display: "inline-block", textAlign: "right", fontSize: 16, fontWeight: "bold", marginLeft: 3}}><Airport airportCode={flight.data[0].originAirportCode}/></div>
          </div>
          {!outboundRequired? 
            <div style={{fontSize: 16, fontWeight: "bold", padding: 10, textAlign: "center", border: "1px solid #ffffff", color: "#000000", backgroundColor: "#dddddd"}}>
              An outbound slot booking is not required.
            </div>              
          :          
            <SlotRow
              data={slotInfo?.data?.outboundSlotInfo}
              airportCode={flight.data[0].originAirportCode}
            />
          }
          <div style={{height: 15}}></div>
          <div className={classes.slotDirectionHeader}>
            <div style={{display: "inline-block"}}><AirplaneLandingIcon style={{position: "relative", top: 2, width: 16, height: 16}}/></div>
            <div style={{display: "inline-block", textAlign: "left", fontSize: 16, fontWeight: "bold", marginLeft: 3}}>Inbound Slots</div>
            <div style={{display: "inline-block", textAlign: "right", fontSize: 16, fontWeight: "bold", marginLeft: 3}}><Airport airportCode={flight.data[0].destinationAirportCode}/></div>
          </div>
          {!inboundRequired? 
            <div style={{fontSize: 16, fontWeight: "bold", padding: 10, textAlign: "center", border: "1px solid #ffffff", color: "#000000", backgroundColor: "#dddddd"}}>
              An inbound slot booking is not required.
            </div>              
          :
            <SlotRow
              data={slotInfo?.data?.inboundSlotInfo}
            />
          }
        </>
      : 
        <></>
      }
    </div>
  </Fragment>); 
}

export default SlotsScreen;